import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import UserContext from '../utils/user-context';

const SelectFacilityRoute = ({ component: Component, props: componentProps, ...rest }) => {
    const context = useContext(UserContext);
    return (
        <Route
            {...rest}
            render = {props => (context.authenticated
                ? <Component {...props} {...componentProps} />
                : <Redirect to="/" />
            )}
        />
    );
};

SelectFacilityRoute.propTypes = {
    component: PropTypes.oneOfType([PropTypes.any]).isRequired,
    props: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.any])),
};

SelectFacilityRoute.defaultProps = {
    props: {},
};

export default SelectFacilityRoute;